import { type FC } from 'react';

const Loading: FC = (): JSX.Element => (
  <>
    <div className='flex justify-center items-center bg-gray-800 h-screen fixed inset-0 z-50'>
      <div className='w-20 h-20 border-4 border-gray-300 border-t-4 border-t-blue-500 rounded-full animate-spin' />
    </div>
  </>
);

export default Loading;
